var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,staticStyle:{"margin":"0 auto"},style:({ height: _vm.height, width: _vm.width }),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }